'use client';

import { useEffect, useState } from 'react';

export const MARKETING_SCROLL_SELECTOR = '.marketing-interior-scroll';

export function getMarketingScrollRoot(fromEl) {
  if (fromEl?.closest) {
    const nested = fromEl.closest(MARKETING_SCROLL_SELECTOR);
    if (nested) return nested;
  }
  return document.querySelector(MARKETING_SCROLL_SELECTOR);
}

export function scrollMarketingSection(id) {
  const el = document.getElementById(id);
  const scroller = getMarketingScrollRoot(el);
  if (!el || !scroller) return;
  const nextTop =
    el.getBoundingClientRect().top - scroller.getBoundingClientRect().top + scroller.scrollTop;
  scroller.scrollTo({ top: Math.max(0, nextTop), behavior: 'smooth' });
}

const SPY_LINE_OFFSET_PX = 120;

export function useMarketingSectionSpy(ids) {
  const [activeId, setActiveId] = useState(ids[0]);

  useEffect(() => {
    const scroller = document.querySelector(MARKETING_SCROLL_SELECTOR);
    const nodes = ids.map(id => document.getElementById(id)).filter(Boolean);
    if (!scroller || !nodes.length) return undefined;

    const updateActive = () => {
      const lineY = scroller.getBoundingClientRect().top + SPY_LINE_OFFSET_PX;
      let current = nodes[0];
      nodes.forEach(section => {
        if (section.getBoundingClientRect().top <= lineY) {
          current = section;
        }
      });
      if (current?.id) {
        setActiveId(current.id);
      }
    };

    updateActive();
    scroller.addEventListener('scroll', updateActive, { passive: true });
    window.addEventListener('resize', updateActive);
    return () => {
      scroller.removeEventListener('scroll', updateActive);
      window.removeEventListener('resize', updateActive);
    };
  }, [ids]);

  return activeId;
}
